import React from "react";
import {useSitePlanningOutcomeQueryQuery} from "../../generated/graphql";
import {GraphQlSelect} from "./GraphQlSelect";

export const SitePlanningOutcomeSelect = (props) => {
    const query = useSitePlanningOutcomeQueryQuery();
    return <GraphQlSelect {...props} queryResult={query} labelField="label"/>;
}
